import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Clock } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);
  const [bookingId, setBookingId] = useState(null);

  useEffect(() => {
    if (!sid || status === "paid") return;
    if (tries > 12) { setStatus("timeout"); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          try {
            const bk = await api.get("/bookings");
            const match = bk.data.find(b => b.session_id === sid);
            if (match) setBookingId(match.booking_id);
          } catch {}
        } else setTries(x => x + 1);
      } catch { setTries(x => x + 1); }
    }, 2000);
    return () => clearTimeout(t);
  }, [sid, tries, status]);

  return (
    <div data-testid="payment-success-page" className="max-w-2xl mx-auto px-6 sm:px-10 py-24 text-center">
      {status === "paid" ? (
        <>
          <CheckCircle2 className="w-16 h-16 text-[#00E699] mx-auto" />
          <h1 className="mt-8 h-editorial text-5xl">Payment <span className="italic-serif text-[#D4AF37]">received.</span></h1>
          <p className="mt-4 text-zinc-400">Your appointment is <span className="text-[#D4AF37]">pending final approval</span>. One private step remains — a per-session consent note.</p>
          <p className="mt-8 max-w-md mx-auto h-editorial italic-serif text-xl sm:text-2xl text-zinc-300">Your time is yours. Come curious.</p>
          {bookingId ? (
            <Link to={`/dashboard/consent/${bookingId}`} data-testid="success-to-consent" className="mt-10 rc-btn-gold inline-block">Continue to Consent →</Link>
          ) : (
            <Link to="/dashboard" data-testid="success-to-dashboard" className="mt-10 rc-btn-primary inline-block">Return to Portal</Link>
          )}
        </>
      ) : status === "timeout" ? (
        <>
          <h1 className="h-editorial text-4xl">Still confirming…</h1>
          <p className="mt-4 text-zinc-400">Your bank is slow. Check your portal in a minute.</p>
          <Link to="/dashboard" className="mt-8 rc-btn-ghost inline-block">Portal</Link>
        </>
      ) : (
        <>
          <Clock className="w-12 h-12 text-[#00D1FF] mx-auto animate-pulse" />
          <h1 className="mt-8 h-editorial text-4xl">Confirming your payment…</h1>
          <p className="mt-4 text-zinc-500 text-sm">Do not close this tab.</p>
        </>
      )}
    </div>
  );
}
